import TaskListPickerController from "./task_list_picker_controller"

// The home dashboard switcher behaves exactly like the tasks list picker —
// search, filter, create-from-filter, create-from-footer, then navigate to the
// created record. Only the identifier differs, so the data-dashboard-picker-*
// attributes bind to the same targets and values.
//
// Rename used to live here as an inline field revealed inside the panel. It moved
// to the arrange modal, which has room for a labelled field and a Save button, so
// it is a plain form post now and needs no JavaScript at all — hence this class is
// back to adding nothing.
export default class extends TaskListPickerController {}
